export enum FilterType {
  age = 'Newest',
  title = 'Alphabetically',
  price = 'Cheapest',
}

export enum ItemsPerPage {
  Four = '4',
  Eight = '8',
  Sixteen = '16',
  All = 'All',
}
